import { Button, Icon } from '@repo/ui/components'
import { useTranslate, MessagesKeys } from '@repo/shared/hooks'
import type { FilterItemProps } from './filteritem.types'
import { cn } from '@repo/ui/lib/utils'

export const FilterItem = ({
  type,
  items,
  label,
  value,
  active,
  onClick,
  onReset,
  hasReset,
}: FilterItemProps) => {
  const { t } = useTranslate()
  const isTranslationKey = (key: string) => key.startsWith('filters_')

  const item = items?.find((item) => item.value === value)
  return (
    <Button
      variant={'ghost'}
      onClick={onClick}
      color={active && type === 'filter' ? 'base' : 'neutral'}
      className={cn(
        active && type === 'filter'
          ? ' border-base-surface-100'
          : 'bg-neutral-surface-5',
        'rounded-sm px-xs py-2xs font-regular',
      )}
      size='sm'
      endIcon={
        hasReset && active && type === 'filter' ? (
          <span
            className=' cursor-pointer flex items-center'
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation()
              onReset?.()
            }}
            aria-label={t('filters_reset' as MessagesKeys)}
          >
            <Icon name='XmarkLine' size='sm' />
          </span>
        ) : undefined
      }
    >
      {!value && t(label as MessagesKeys)}
      {value === 'all' && t(label as MessagesKeys)}
      {value && value !== t(label as MessagesKeys) && value !== 'all' && (
        <span className='ml-xs'>
          {item?.labelKey && isTranslationKey(item?.labelKey as string)
            ? t(item?.labelKey as MessagesKeys)
            : item?.label || value}
        </span>
      )}
      {type === 'sort' && <Icon name='TriangleDown' className='size-icon-sm' />}
    </Button>
  )
}
